<template>
  <div class="anuncio jumbotron ma-0 pa-0" v-if="shouldShowBanner">
    <v-container grid-list-xs text-xs-center>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card flat>
            <a
              :href="bannerContent.ctaUrl"
              :target="bannerContent.ctaTarget || '_blank'"
              rel="noopener noreferrer"
            >
              <img
                class="center-block img-responsive"
                :src="bannerContent.image"
                :alt="bannerContent.title"
              />
            </a>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<style>
.anuncio .center-block {
  margin: 0;
  width: 100%;
}
</style>
<script>
import { getBanner } from '@/config/servicios'

export default {
  data() {
    return {
      bannerData: null,
      loading: true,
    }
  },
  async mounted() {
    await this.loadBanner()
  },
  computed: {
    ahora() {
      return this.$store.state.ahora
    },
    locale() {
      return this.$i18n.locale
    },
    shouldShowBanner() {
      if (!this.bannerData || this.loading) return false

      // Check if banner is active
      if (
        !this.bannerData.isActive ||
        !this.bannerData.visible ||
        this.bannerData.status !== 'active'
      ) {
        return false
      }

      // Check schedule if it exists
      if (this.bannerData.schedule) {
        const now = new Date()
        const startDate = new Date(this.bannerData.schedule.startDate)
        const endDate = new Date(this.bannerData.schedule.endDate)

        if (now < startDate || now > endDate) {
          return false
        }
      }

      return true
    },
    bannerContent() {
      if (!this.bannerData) return {}

      const content = this.bannerData.content || {}

      // Get locale-specific content if available, otherwise use default
      if (content.lang && content.lang[this.locale]) {
        return {
          ...content,
          ...content.lang[this.locale],
        }
      }

      return content
    },
  },
  methods: {
    async loadBanner() {
      try {
        // Load the banner with the ID
        const banner = await getBanner('banner-1755535571476')

        if (banner && banner.statusText !== 'NOK') {
          this.bannerData = banner
        }
      } catch (error) {
        console.error('Error loading banner:', error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
